module.exports = __webpack_public_path__ + "img/setup.d1b6a373.png";